var render = function render() {
  var _vm = this,
      _c = _vm._self._c;return _c('div', { staticClass: "instructions" }, [_c('h4', [_vm._v("使用步骤")]), _vm._v(" "), _c('div', { staticClass: "steps" }, [_c('el-steps', { attrs: { "direction": "vertical" } }, _vm._l(_vm.steps, function (step, index) {
    return _c('el-step', { key: index, attrs: { "description": step } });
  }), 1)], 1)]);
};
var staticRenderFns = [];

export { render, staticRenderFns };